module.exports = __webpack_public_path__ + "static/media/qr-pay.bbb8142e.png";